(function () {
  if (window.__drUi) return; window.__drUi = true;
  var D = document, W = window;
  var design = !!(W.Shopify && Shopify.designMode);
  var reduce = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var main = D.getElementById('MainContent');
  var tpl = (main && main.getAttribute('data-template')) || '';
  var isHome = tpl === 'index', isProduct = tpl.indexOf('product') === 0;

  function el(tag, cls, html) { var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function zl(n) { n = Math.round(n); return n + ' zł'; }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function rentPrice(variants, cents) {
    var best = null;
    (variants || []).forEach(function (v) {
      var opts = v.options || [v.option1, v.option2, v.option3];
      var isRent = opts.some(function (o) { return o === 'Wypożyczenie'; });
      var p = cents ? v.price / 100 : parseFloat(v.price);
      if (isRent && (best === null || p < best)) best = p;
    });
    if (best === null) (variants || []).forEach(function (v) { var p = cents ? v.price / 100 : parseFloat(v.price); if (best === null || p > best) best = p; });
    return best;
  }
  var ICON_IG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".9" fill="currentColor"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- Modal ---------- */
  var modal, modalBody;
  function openModal(html, wide) {
    if (!modal) {
      modal = el('div', 'dr-modal');
      modal.innerHTML = '<div class="dr-modal__bg" data-close></div><div class="dr-modal__box" role="dialog" aria-modal="true"><button class="dr-modal__x" data-close aria-label="Zamknij">' + ICON_X + '</button><div class="dr-modal__body"></div></div>';
      D.body.appendChild(modal);
      modalBody = modal.querySelector('.dr-modal__body');
      modal.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeModal(); });
      D.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
    modal.classList.toggle('dr-modal--wide', !!wide);
    modalBody.innerHTML = html;
    D.documentElement.classList.add('dr-lock');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
  }
  function closeModal() { if (!modal) return; modal.classList.remove('is-open'); D.documentElement.classList.remove('dr-lock'); }

  /* ---------- Jak to dziala: przeniesienie ---------- */
  function moveSteps() {
    var steps = D.getElementById('dr-steps');
    if (!steps || !main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (sections.length > 1) sections[0].after(steps); else main.appendChild(steps);
    var brands = D.getElementById('dr-brands');
    if (brands) steps.after(brands);
  }

  /* ---------- Reveal przy przewijaniu ---------- */
  var io = null;
  function observe(t, delay) {
    if (reduce || design || !io) return;
    if (t.__drObs) return; t.__drObs = true;
    if (t.getBoundingClientRect().top < W.innerHeight * 0.95) return;
    t.classList.add('dr-reveal');
    if (delay) t.style.transitionDelay = delay + 's';
    io.observe(t);
  }
  function initReveal() {
    if (reduce || design || !('IntersectionObserver' in W)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dr-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    if (main) main.querySelectorAll(':scope > .shopify-section').forEach(function (s, i) { if (i > 0 && !s.querySelector('.product-grid')) observe(s); });
    D.querySelectorAll('.dr-step').forEach(function (s, i) { observe(s, (i % 3) * 0.12); });
    setTimeout(function () { D.querySelectorAll('.dr-reveal').forEach(function (x) { x.classList.add('dr-in'); }); }, 7000);
  }

  /* 4. Karty wjezdzajace po kolei */
  function initCards() {
    if (!io) return;
    var items = D.querySelectorAll('.product-grid__item, .product-grid > li');
    var n = 0;
    items.forEach(function (it) {
      if (it.__drObs) return;
      observe(it, (n++ % 4) * 0.08);
    });
  }

  /* 3. Animowany baner glowny */
  function initHero() {
    if (!isHome || reduce || design || !main) return;
    var first = main.querySelector(':scope > .shopify-section');
    if (!first) return;
    var img = first.querySelector('img');
    if (img) { if (img.parentElement) img.parentElement.style.overflow = 'hidden'; img.classList.add('dr-ken'); }
    var txt = first.querySelectorAll('h1, h2, h3, p, .button, a[class*="button"]');
    var k = 0;
    txt.forEach(function (t) { if (k > 6 || !t.textContent.trim()) return; t.classList.add('dr-hero-txt'); t.style.animationDelay = (0.25 + 0.15 * k++) + 's'; });
  }

  /* 6. Szybki podglad */
  function initQuickView() {
    if (!fine) return;
    D.querySelectorAll('.card-gallery').forEach(function (g) {
      if (g.__drQv) return;
      var a = g.querySelector('a[href*="/products/"]');
      if (!a) return;
      g.__drQv = true;
      var b = el('button', 'dr-qv-btn', 'Szybki podgląd');
      b.type = 'button';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); quickView(a.getAttribute('href')); });
      g.appendChild(b);
    });
  }
  function quickView(href) {
    var url = href.split('?')[0].split('#')[0];
    openModal('<div class="dr-qv dr-qv--loading"><div class="dr-spinner"></div></div>', true);
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var price = rentPrice(p.variants, true);
      var imgs = (p.images || []).slice(0, 5);
      var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      var cut = desc.split(/WYMIARY/i)[0].trim();
      if (cut.length > 260) cut = cut.slice(0, 260).replace(/\s\S*$/, '') + '…';
      var opts = (p.options || []).filter(function (o) { return o.name !== 'Usługa' && o.name !== 'Title'; })
        .map(function (o) { return '<div class="dr-qv__opt"><span>' + esc(o.name) + ':</span> ' + esc((o.values || []).join(', ')) + '</div>'; }).join('');
      var thumbs = imgs.length > 1 ? '<div class="dr-qv__thumbs">' + imgs.map(function (s, i) { return '<button type="button" data-src="' + esc(sized(s, 900)) + '" class="' + (i === 0 ? 'is-active' : '') + '"><img src="' + esc(sized(s, 160)) + '" alt=""></button>'; }).join('') + '</div>' : '';
      modalBody.innerHTML =
        '<div class="dr-qv">' +
          '<div class="dr-qv__media"><img class="dr-qv__main" src="' + esc(sized(imgs[0], 900)) + '" alt="' + esc(p.title) + '">' + thumbs + '</div>' +
          '<div class="dr-qv__info">' +
            (p.vendor && p.vendor !== 'Dresly' ? '<div class="dr-qv__brand">' + esc(p.vendor) + '</div>' : '') +
            '<h3 class="dr-qv__title">' + esc(p.title) + '</h3>' +
            (price ? '<div class="dr-qv__price">Wypożyczenie ' + zl(price) + ' <small>· przymiarka 40 zł</small></div>' : '') +
            opts +
            (cut ? '<p class="dr-qv__desc">' + esc(cut) + '</p>' : '') +
            '<a class="dr-qv__cta" href="' + esc(url) + '">Wybierz termin i zarezerwuj</a>' +
            '<a class="dr-qv__more" href="' + esc(url) + '">Zobacz wszystkie szczegóły →</a>' +
          '</div>' +
        '</div>';
      modalBody.querySelectorAll('.dr-qv__thumbs button').forEach(function (t) {
        t.addEventListener('click', function () {
          modalBody.querySelector('.dr-qv__main').src = t.getAttribute('data-src');
          modalBody.querySelectorAll('.dr-qv__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }).catch(function () { W.location.href = url; });
  }

  /* 7. Lupa na zdjeciach produktu */
  function initZoom() {
    if (!isProduct || !fine) return;
    D.querySelectorAll('.product-media-container').forEach(function (c) {
      if (c.__drZoom || c.closest('.card-gallery')) return;
      var img = c.querySelector('img'); if (!img) return;
      c.__drZoom = true;
      c.classList.add('dr-zoom');
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      c.addEventListener('mouseenter', function () { img.classList.add('is-zoomed'); });
      c.addEventListener('mouseleave', function () { img.classList.remove('is-zoomed'); img.style.transformOrigin = ''; });
    });
  }

  /* 8. Tabela wymiarow */
  function initSizes() {
    if (!isProduct || !main) return;
    var perks = D.querySelector('.dr-perks');
    if (!perks || D.querySelector('.dr-size-btn')) return;
    var label = null;
    main.querySelectorAll('p, strong, b, span, h4, h5, h6').forEach(function (n) {
      if (!label && n.textContent.trim().toUpperCase() === 'WYMIARY') label = n.closest('p, h4, h5, h6') || n;
    });
    if (!label) return;
    var rows = [], n = label.nextElementSibling, guard = 0;
    while (n && guard++ < 12) {
      var t = n.textContent.replace(/\u00a0/g, ' ').trim();
      if (t) {
        var m = t.match(/^([^\d]+?)\s*[:\-–]?\s*(\d[\d\s,.\-–]*\s*cm)\s*$/i);
        if (m) rows.push([m[1].trim(), m[2].trim()]); else if (rows.length) break;
      }
      n = n.nextElementSibling;
    }
    if (!rows.length) return;
    var btn = el('button', 'dr-size-btn', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/></svg><span>Sprawdź wymiary sukienki</span>');
    btn.type = 'button';
    btn.addEventListener('click', function () {
      var title = (D.querySelector('main h1') || {}).textContent || '';
      openModal('<div class="dr-sizes"><h3>Wymiary' + (title ? ' – ' + esc(title.trim()) : '') + '</h3><table>' +
        rows.map(function (r) { return '<tr><th>' + esc(r[0].charAt(0).toUpperCase() + r[0].slice(1)) + '</th><td>' + esc(r[1]) + '</td></tr>'; }).join('') +
        '</table><p>Porównaj z własnymi wymiarami. Masz wątpliwości? Umów przymiarkę za 40 zł i sprawdź sukienkę na sobie.</p></div>');
    });
    perks.parentNode.insertBefore(btn, perks);
  }

  /* 9. Zobacz tez */
  function getCatalog() {
    var KEY = 'drCatalog1';
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 15 * 60 * 1000) return Promise.resolve(c.p);
    } catch (e) {}
    return fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (data) {
      var slim = (data.products || []).map(function (p) {
        return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, product_type: p.product_type,
          options: (p.options || []).map(function (o) { return { name: o.name, values: o.values }; }),
          variants: (p.variants || []).map(function (v) { return { price: v.price, option1: v.option1, option2: v.option2, option3: v.option3 }; }),
          images: (p.images || []).slice(0, 1).map(function (i) { return { src: i.src }; }) };
      });
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: slim })); } catch (e) {}
      return slim;
    });
  }
  function initRelated() {
    if (!isProduct || !main || D.getElementById('dr-related')) return;
    var handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
    if (!handle) return;
    getCatalog().then(function (products) {
      var all = (products || []).filter(function (p) { return p.product_type !== 'deposit'; });
      var cur = all.filter(function (p) { return p.handle === decodeURIComponent(handle); })[0];
      if (!cur) return;
      function colorOf(p) { var o = (p.options || []).filter(function (x) { return x.name === 'Kolor'; })[0]; return o ? o.values : []; }
      var cc = colorOf(cur);
      var scored = all.filter(function (p) { return p.id !== cur.id && p.images && p.images.length; }).map(function (p) {
        var s = 0;
        if (cur.vendor && cur.vendor !== 'Dresly' && p.vendor === cur.vendor) s += 3;
        if (colorOf(p).some(function (c) { return cc.indexOf(c) > -1; })) s += 2;
        if (p.product_type && p.product_type === cur.product_type) s += 1;
        return { p: p, s: s + Math.random() * 0.5 };
      }).sort(function (a, b) { return b.s - a.s; }).slice(0, 10);
      if (!scored.length) return;
      var sameBrand = cur.vendor && cur.vendor !== 'Dresly' && scored[0].p.vendor === cur.vendor;
      var sec = el('section', 'dr-related');
      sec.id = 'dr-related';
      sec.innerHTML = '<div class="dr-related__head"><h2>' + (sameBrand ? 'Więcej od ' + esc(cur.vendor) + ' i w podobnym stylu' : 'Zobacz też') + '</h2>' +
        '<div class="dr-related__nav"><button type="button" data-dir="-1" aria-label="Poprzednie">‹</button><button type="button" data-dir="1" aria-label="Następne">›</button></div></div>' +
        '<div class="dr-related__track">' + scored.map(function (x) {
          var p = x.p, pr = rentPrice(p.variants, false);
          return '<a class="dr-related__card" href="/products/' + esc(p.handle) + '"><div class="dr-related__img"><img loading="lazy" src="' + esc(sized(p.images[0].src, 500)) + '" alt="' + esc(p.title) + '"></div>' +
            (p.vendor && p.vendor !== 'Dresly' ? '<div class="dr-related__brand">' + esc(p.vendor) + '</div>' : '') +
            '<div class="dr-related__title">' + esc(p.title) + '</div>' + (pr ? '<div class="dr-related__price">' + zl(pr) + '</div>' : '') + '</a>';
        }).join('') + '</div>';
      var mainSection = main.querySelector(':scope > .shopify-section');
      if (mainSection) mainSection.after(sec); else main.appendChild(sec);
      var track = sec.querySelector('.dr-related__track');
      sec.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8 * (+b.getAttribute('data-dir')), behavior: 'smooth' }); });
      });
      observe(sec);
    }).catch(function () {});
  }

  /* 12. Liczniki */
  function initCounters() {
    if (!isHome || !main) return;
    var list = [];
    main.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, strong, div').forEach(function (n) {
      if (n.children.length || n.closest('.dr-steps, .dr-brands, .price, product-card, .product-card, header')) return;
      var t = n.textContent.trim();
      var m = t.match(/^(\d{1,3}(?:[ \u00a0.]\d{3})*|\d+)([.,]\d+)?\s*(\+|%|k\+?|tys\.?\+?)?$/i);
      if (!m) return;
      var val = parseFloat((m[1] + (m[2] || '')).replace(/[ \u00a0.]/g, '').replace(',', '.'));
      if (!(val >= 5)) return;
      list.push({ n: n, val: val, dec: m[2] ? m[2].length - 1 : 0, sep: /[ \u00a0.]/.test(m[1]), suf: m[3] || '', orig: t });
    });
    if (!list.length) return;
    function fmt(v, c) {
      var s = v.toFixed(c.dec);
      if (c.sep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return s.replace('.', ',') + (c.suf ? (/^\+|%$/.test(c.suf) ? '' : ' ') + c.suf : '');
    }
    function run(c) {
      if (reduce) return;
      var start = null, dur = 1600;
      c.n.style.fontVariantNumeric = 'tabular-nums';
      function step(ts) {
        if (!start) start = ts;
        var k = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - k, 3);
        c.n.textContent = k < 1 ? fmt(c.val * e, c) : c.orig;
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in W)) return;
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cio.unobserve(e.target); run(e.target.__drC); } }); }, { threshold: 0.4 });
    list.forEach(function (c) { c.n.__drC = c; if (!reduce) c.n.textContent = fmt(0, c); cio.observe(c.n); });
  }

  /* 14. Kursor */
  function initCursor() {
    if (!fine || reduce || design) return;
    var dot = el('div', 'dr-cursor'); D.body.appendChild(dot);
    var x = -100, y = -100, cx = -100, cy = -100, shown = false, raf = 0;
    function loop() {
      cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
      dot.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      raf = (Math.abs(x - cx) + Math.abs(y - cy) > 0.4) ? requestAnimationFrame(loop) : 0;
    }
    D.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!shown) { shown = true; cx = x; cy = y; dot.classList.add('is-on'); }
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    D.addEventListener('mouseleave', function () { shown = false; dot.classList.remove('is-on'); });
    var big = false;
    D.addEventListener('mouseover', function (e) {
      var b = !!e.target.closest('a, button, [role="button"], img, label, select, input');
      if (b !== big) { big = b; dot.classList.toggle('is-big', b); }
    }, { passive: true });
  }

  /* 15 + 16. Przycisk do gory i Instagram */
  function initFloating() {
    var wrap = el('div', 'dr-float' + (isProduct ? ' dr-float--product' : ''));
    wrap.innerHTML = '<button type="button" class="dr-top" aria-label="Przewiń do góry"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg></button>' +
      '<a class="dr-igf" href="https://ig.me/m/dresly_wypozyczalniasukienek" target="_blank" rel="noopener" aria-label="Napisz do nas na Instagramie">' + ICON_IG + '<span>Napisz do nas</span></a>';
    D.body.appendChild(wrap);
    var top = wrap.querySelector('.dr-top');
    top.addEventListener('click', function () { W.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var ticking = false;
    W.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { top.classList.toggle('is-on', W.scrollY > 700); ticking = false; });
    }, { passive: true });
  }

  /* 17. Animacja dodania do koszyka */
  var toast;
  function cartBump() {
    var icon = D.querySelector('header a[href$="/cart"], header [href*="/cart"], header cart-icon, header .header-actions__cart-icon, header [aria-label*="oszyk"], header [aria-label*="art"]');
    if (icon) { icon.classList.remove('dr-bump'); void icon.offsetWidth; icon.classList.add('dr-bump'); }
    if (!toast) { toast = el('div', 'dr-toast'); D.body.appendChild(toast); }
    toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> Dodano do koszyka';
    toast.classList.add('is-on');
    clearTimeout(toast.__t); toast.__t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }
  function initCart() {
    var last = 0;
    function fire() { var now = Date.now(); if (now - last < 800) return; last = now; cartBump(); }
    if (W.fetch && !W.fetch.__dr) {
      var of = W.fetch;
      W.fetch = function (input, init) {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var p = of.apply(this, arguments);
        if (/\/cart\/add/.test(u)) p.then(function (r) { if (r && r.ok) fire(); }).catch(function () {});
        return p;
      };
      W.fetch.__dr = true;
    }
  }

  function idle(fn) {
    var run = function () { if ('requestIdleCallback' in W) W.requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 1200); };
    if (D.readyState === 'complete') run(); else W.addEventListener('load', run, { once: true });
  }

  function initDynamic() { initCards(); initQuickView(); initZoom(); }

  function init() {
    moveSteps();
    initReveal();
    initHero();
    initCounters();
    initDynamic();
    initSizes();
    idle(initRelated);
    initFloating();
    idle(initCursor);
    initCart();
    if (main && 'MutationObserver' in W && main.querySelector('.card-gallery, .product-media-container')) {
      var t;
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { clearTimeout(t); t = setTimeout(initDynamic, 250); return; } }
      }).observe(main, { childList: true, subtree: true });
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
